import * as React from 'react';
import ReactDOM from 'react-dom';

import ReCAPTCHA from "react-google-recaptcha";

import { Dialog,DialogFooter  } from 'office-ui-fabric-react/lib/Dialog';
import { PrimaryButton, DefaultButton} from 'office-ui-fabric-react/lib/Button';

import { TextField } from 'office-ui-fabric-react/lib/TextField';

import { Config } from './Config.js';
import { Utils } from './classi/Utils.js';

import { LoginWindow } from './LoginWindow.js';

import './css/DialogBox.css';
import './css/PrimoAccesso.css';

const config = new Config();
const utils = new Utils();
const recaptchaRef = React.createRef();

export class RecuperaPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hidden: false,
            version : config.getVersion(),
            codcliente: '',
            email: '',
            
            codclienteError : '...compilare...',
            emailError : '...compilare...',

            classemostra : '',

            classLogo : 'logo',

            buttonDisabled : false,
            messaggio : '',
            
            captcha : '', // captchaLetto
            // reCaptcha V2 - account Flossi
            apiKeyReCaptcha : config.getReCaptchaClient(),
            classeHeader : 'loginpage'
        };

        this.execLogin = this.execLogin.bind(this);
        
        this.controllaParametri = utils.controllaParametri.bind(this);    
        this._onChangeCaptcha = this._onChangeCaptcha.bind(this);
    }
    
    componentDidMount() {
        this.centralogo(0);
        this.controllaParametri(0);
    }
    
    
    centralogo(conta){
        let posLogo = utils.getObjInfoSocieta( 'POSIZIONELOGOAC2' , false );
        if( posLogo !== false && conta < 50 ) {  
            if(posLogo === 'centro'){ this.setState({classeHeader: 'loginpage pagecentrato'}); } 
            let logolargo = utils.getObjInfoSocieta( 'LOGOLARGO' , false );
            if( logolargo !== false && logolargo==='SI'){ this.setState({classLogo: 'logo logolargo'}); }
        }
        else { setTimeout( function(){  this.centralogo( conta+1 );  }.bind(this) , 50 ); }
    }
  
    _controllaAbilitazioneBottone()
    {
        setTimeout( function(){
            
            var abilitato = true;
            
            if( this.state.codclienteError !== ''){ abilitato = false }
            if( this.state.emailError !== ''){ abilitato = false }
            if( this.state.captcha === ''){ abilitato = false }
            
            this.setState({ buttonDisabled:!abilitato });
            
        }.bind(this) , 100 );
    }
    
    
    codclienteChanged = (newValue) => { 
        if( newValue.length === 0 ){this.setState({codcliente: newValue,codclienteError: '...compilare...'}); }
        else{this.setState({codcliente: newValue,codclienteError: ''}); }
        
        this._controllaAbilitazioneBottone();
    }

    emailChanged = (newValue) => { 
        if( newValue.length === 0 ){this.setState({email: newValue,emailError: '...compilare...'}); }
        else
        {
            let isValidMail = utils.validateEmail(newValue);
            if(isValidMail){ this.setState({email: newValue, emailError: ''}); }
            else{this.setState({email: newValue,emailError: '...mail non valida...'});}
        }
        
        this._controllaAbilitazioneBottone();
    }

  
    _onChangeCaptcha(value){
        this.setState({captcha: 'selezionato'});
        this._controllaAbilitazioneBottone();
    }
  
  
    execLogin = (event) => {
        this.setState({messaggio:'',codclienteError: '', passwordError: ''});

        let request = new Request( config.get("customers_firstloginmail") ,{
            method: 'POST',mode: 'cors', credentials: "include",
            body: JSON.stringify({action:'recuperapassword', username: this.state.codcliente, mail: this.state.email , pathAC: config.get("pathAC2") })
        });
       
        fetch(request)
        .then(function(response){
            return response.json();
        })
        .then(function(result){
            if (result.success){
                // qui provo il caricamento del pannello
                this.setState({messaggio:'Dati inviati Correttamente. Controlla la tua E-Mail', classemostra:'nascosto'});
            } else {
                this.setState({messaggio: result.message});
            }
        }.bind(this)).catch(function() {
            this.setState({messaggio: 'Errore invio dati'});
        }.bind(this));
    }

    tornalogin = (event) => {
        ReactDOM.render(<LoginWindow />, document.getElementById('root'));
    }

    render() {
        return (
        <div id="main-container" className="loginpage">
        <header className={this.state.classeHeader}><span className={this.state.classLogo}>&nbsp;</span>&nbsp;</header>
        
        <Dialog dialogContentProps={{ title : "Recupera Password" }} hidden={this.state.hidden}  modalProps={{ isBlocking: true, containerClassName: 'ms-dialogMainOverride primoaccesso' }} >
            
            <div>{this.state.messaggio}</div>
            <div>
                <TextField className={this.state.classemostra} label="Codice cliente" required={true} errorMessage={this.state.codclienteError} value={this.state.codcliente} onChanged={this.codclienteChanged} iconProps={{iconName: 'Contact'}}/>
                <TextField className={this.state.classemostra} label="E-Mail" errorMessage={this.state.emailError} type='email' required={true} value={this.state.email} iconProps={{iconName: 'Mail'}} onChanged={this.emailChanged} />
                    
                <ReCAPTCHA className="boxReCaptcha" ref={recaptchaRef} sitekey={this.state.apiKeyReCaptcha} onChange={this._onChangeCaptcha} />
            </div>
            
            <DialogFooter>
                <PrimaryButton className={this.state.classemostra} text="Recupera" primary={true} onClick={this.execLogin} disabled={this.state.buttonDisabled}/>
                <DefaultButton text="Indietro" onClick={this.tornalogin} />
            </DialogFooter>
        </Dialog>
        <footer className="loginpage"><i className="ms-Icon ms-Icon--Info" aria-hidden="true"></i> Versione {this.state.version}</footer>
        </div>
        );
    }  
  
}

export default RecuperaPassword;


// WEBPACK FOOTER //
// ./src/AcComponents/RecuperaPassword.js